export default "__VITE_ASSET__DvZsKPxc__"